import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFindingsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.47 13.97a.75.75 0 0 1 1.06 0l2.475 2.474a.75.75 0 0 1-1.06 1.061L14.47 15.03a.75.75 0 0 1 0-1.06M1.75 4.5a.75.75 0 0 1 .75-.75H10a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-8.693-2.8a.8.8 0 0 1 1.386 0l1.212 2.1a.8.8 0 0 1-.693 1.2H2.788a.8.8 0 0 1-.693-1.2zM4 14l-.866 1.5h1.732zM14.307 3.2a.8.8 0 0 1 1.386 0l1.212 2.1a.8.8 0 0 1-.693 1.2h-2.424a.8.8 0 0 1-.693-1.2zM15 4l-.866 1.5h1.732z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFindingsOutline;
